let prefix = '/api/exportData';

function exportDataExcel(data) {
    return window.axios.post(prefix+'/excel',data,{ responseType: 'blob' });
}

export default {
    exportDataExcel,

}